export default __webpack_public_path__ + "static/media/produto_sem-imagem.e9f0a653.svg";